import { render, staticRenderFns } from "./sga.vue?vue&type=template&id=c2b6a446"
import script from "./sga.vue?vue&type=script&lang=js"
export * from "./sga.vue?vue&type=script&lang=js"
import style0 from "./sga.vue?vue&type=style&index=0&id=c2b6a446&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports